import Vue from 'vue';
import t from "@/service/SysMsgService";
import dictEnum from "@/constants/SysMsgDict";
import { Validator } from 'vee-validate';
export default function () {
    this.StaffFixAlwValidation = function () {
        const dictonary = {
            custom: {
                DateEff: {
                    required: () =>
                        t.t(dictEnum.LBL_Date) + t.t(dictEnum.WARN_IsRequired)
                },
                IncType: {
                    required: () =>
                        t.t(dictEnum.LBL_IncType) + t.t(dictEnum.WARN_IsRequired)
                },
                IncSubType: {
                    required: () =>
                        t.t(dictEnum.LBL_IncSubType) + t.t(dictEnum.WARN_IsRequired)
                },
                Amt: {
                    required: () =>
                        t.t(dictEnum.LBL_Amount) + t.t(dictEnum.WARN_IsRequired)
                }
            }
        };
        Validator.localize('en', dictonary);
    }
}



// WEBPACK FOOTER //
// ./src/components/S070000-Employee/S070200-EmployeeProfile/StaffFixAlw/StaffFixAlwValidation.js